/* 名前入力欄 */
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from '../molecules/Paragraph';

interface Props {
  first_id: string;
  last_id: string;
  label: string;
  need?: boolean;
  first_value: string;
  last_value: string;
  first_name: string;
  last_name: string;
  first_placeholder: string;
  last_placeholder: string;
  first_maxlength?: number;
  last_maxlength?: number;
  handleChangeFirstName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeLastName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  help_msg?: string;
  first_disabled: boolean;
  last_disabled: boolean;
  handleBlurFirstName: VoidFunction;
  handleBlurLastName: VoidFunction;
  readonly?: boolean;
}

const NameInput: React.FC<Props> = ({
  first_id,
  last_id,
  label,
  need,
  first_name,
  last_name,
  first_value,
  last_value,
  first_placeholder,
  last_placeholder,
  first_maxlength,
  last_maxlength,
  handleChangeFirstName,
  handleChangeLastName,
  message,
  help_msg,
  first_disabled,
  last_disabled,
  handleBlurFirstName,
  handleBlurLastName,
  readonly,
}) => {
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={first_disabled || last_disabled}
      content={
        first_disabled || last_disabled ? (
          <Paragraph label={`${last_value} ${first_value}`} />
        ) : (
          <>
            <Row>
              <Col xs={6} className="pr-1">
                <Form.Control
                  id={last_id}
                  type="text"
                  name={last_name}
                  onChange={handleChangeLastName}
                  value={last_value}
                  placeholder={last_placeholder}
                  disabled={last_disabled || readonly}
                  onBlur={handleBlurLastName}
                  maxLength={last_maxlength}
                />
              </Col>
              <Col xs={6} className="pl-1">
                <Form.Control
                  id={first_id}
                  type="text"
                  name={first_name}
                  onChange={handleChangeFirstName}
                  value={first_value}
                  placeholder={first_placeholder}
                  disabled={first_disabled || readonly}
                  onBlur={handleBlurFirstName}
                  maxLength={first_maxlength}
                />
              </Col>
            </Row>
            <Messages help_msg={help_msg} valid_msg={message} />
          </>
        )
      }
    />
  );
};

export default NameInput;
